<template>
  <div class="search-container">
    <div class="head">
      <div class="input-container">
        <div class="input">
          <input type="text" id="keywordinput" v-model="searchWord" @keyup.enter="searchInfo" placeholder="请输入搜索内容" />
          <button @click="searchInfo">
            <span></span>
          </button>
        </div>
      </div>
    </div>
    <div class="type-nav">
      <span :class="typeActive == 1 ? 'active' : ''" @click="goToArticle">文章</span>
      <span :class="typeActive == 2 ? 'active' : ''" @click="goToNewsFlash">快讯</span>
      <hr />
    </div>
    <div class="main">
      <router-view  ref="childerPage"/>
    </div>
    <div class="foot">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeActive: -1,
      hidePageNav: true,
      searchWord: "",
      hotWords: [],
      pageNum: 0,
      pageSize: 1,
      totlePage: 0,
      orderActive: 1,
      newarticlelist: [],
      seach: ""
    };
  },
  created: async function () {
    let path = this.$route.path;
    if(path!='/search'){
      let t = sessionStorage.getItem('searchType');
      let s = sessionStorage.getItem('searchValue');
      if(!t){
        if(this.typeActive==-1){
          this.typeActive = 1;
        }
      }else{
        this.typeActive = t*1;
      }
      if(s){
        this.searchWord = s;
      }
    }else{
      this.searchWord = this.$route.params.name;
      this.typeActive = 1;
      sessionStorage.removeItem('searchType');
      sessionStorage.removeItem('searchValue');
    }
    sessionStorage.setItem('searchType',this.typeActive);
    this.searchInfo();
  },

  methods: {
    //回车事件
    Searched() {
      this.searchInfo();
    },

    //关键进入文章页面
    goToArticle() {
      this.typeActive = 1;
      this.searchInfo();
    },

    //关键词进入快讯页面
    goToNewsFlash() {
      this.typeActive = 2;
      this.searchInfo();
    },

    //点击查询
    async searchInfo() {
      let path = this.$route.path;
      let pageObj = this.$refs.childerPage;
      sessionStorage.setItem('searchType',this.typeActive);
      sessionStorage.setItem('searchValue',this.searchWord);
      function cp(){
        this.$refs.childerPage.currentPage(1,this.searchWord);
      }

      if (this.typeActive == 1) {
        if(path=='/contents'){
          this.$nextTick(cp)
        }else{
          this.$router.push({
            path: "/contents",
            query: {
              searchWord: this.searchWord
            }
          });
        }
      } else if (this.typeActive == 2) {
        if(path=='/newsflashs'){
          this.$nextTick(cp)
        }else{
          this.$router.push({
            path: "/newsflashs",
            query: {
              searchWord: this.searchWord
            }
          });
        }
      }
    },
  }
};
</script>

<style>
.search-container {
  text-align: center;
}

.search-container>.head {
  height: 164px;
  background: rgba(229, 229, 229, 1);
  width: 100%;
  text-align: center;
  position: relative;
  display: inline-block;
}

.search-container>.head>.input-container {
  left: 50%;
  top: 50%;
  margin-left: -322px;
  margin-top: -24px;
  height: 44px;
  width: 645px;
  position: absolute;
}

.search-container>.head>.input-container>.input {
  height: 48px;
}

.search-container>.head>.input-container>.input input {
  width: 527px;
  height: 40px;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  border-width: 0px;
  padding-left: 24px;
}

.search-container>.head>.input-container>.input button {
  width: 88px;
  height: 42px;
  cursor: pointer;
  background: #0084ff;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  border-width: 0px;
  vertical-align: bottom;
}

.search-container>.head>.input-container>.input>button>span {
  height: 24px;
  width: 24px;
  display: inline-block;
  background-image: url(~@/assets/fdj1.png);
  background-repeat: no-repeat;
  background-size: 25px 25px;
}

.search-container>.head>.input-container>.hint {
  margin-top: 28px;
  text-align: left;
}

.search-container>.main {
  min-height: 432px;
  margin-top: 34px;
  text-align: center;
  display: inline-block;
  width: 100%;
  background-color: #f7f7f7;
  padding-top: 36px;
}

.search-container>.foot {
  text-align: center;
  width: 100%;
  display: inline-block;
}

.search-container>.foot>.hot-keyword {
  display: inline-block;
  height: 185px;
  width: 900px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(99, 99, 99, 1);
  line-height: 34px;
  text-align: left;
}

.search-container>.foot>.hot-keyword>.content span {
  margin-right: 15px;
  display: inline-block;
}

/* 类型导航栏------- */
.search-container .type-nav {
  font-size: 16px;
  font-weight: normal;
  color: #060505;
  text-align: center;
  height: 36px;
}

.search-container .type-nav span:not(:first-of-type) {
  margin-left: 45px;
}

.search-container .type-nav>span {
  display: inline-block;
  width: 50px;
  position: relative;
  padding-top: 8px;
  cursor: pointer;
}

.search-container .type-nav>.active:after {
  content: " ";
  width: 6px;
  height: 6px;
  background: #0084ff;
  border-radius: 3px;
  display: inline-block;
  position: absolute;
  bottom: -18px;
  left: 50%;
  margin-left: -3px;
}

.search-container .type-nav hr {
  width: 829px;
  height: 0.5 px;
  border: 1px solid rgba(191, 191, 191, 1);
  margin-top: 14px;
  background-color: rgba(191, 191, 191, 1);
}

input {
  outline: none;
}

button {
  outline: none;
}</style>